import { createSelector } from "@reduxjs/toolkit";
import { isEqual } from "lodash";
import { toUpdateRequest } from "slices/settings/shreddingTemplatesRequest";

import { selectSettingsState } from ".";

export const selectShreddingTemplatesSlice = createSelector(
  [selectSettingsState],
  (settings) => settings.shreddingTemplates
);

export const selectShreddingTemplates = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.templates
);

export const selectShreddingTemplatesIsLoading = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.isLoading
);

export const selectShreddingTemplatesError = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.error
);

export const selectShreddingTemplateById = createSelector(
  [selectShreddingTemplates, (_state, id) => id],
  (templates, id) =>
    (templates ?? []).find((template) => String(template.id) === String(id))
);

export const selectShreddingTemplateDetailIsLoading = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.detail.isLoading
);

export const selectShreddingTemplateDetailError = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.detail.error
);

export const selectShreddingTemplatesIsCreating = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.isCreating
);

export const selectShreddingTemplateEdit = createSelector(
  [selectShreddingTemplatesSlice],
  (shreddingTemplates) => shreddingTemplates.edit
);

export const selectIsShreddingTemplateDraftDirty = createSelector(
  [selectShreddingTemplateEdit],
  (edit) =>
    Boolean(edit) &&
    !isEqual(toUpdateRequest(edit.draft), toUpdateRequest(edit.original))
);
